import { render, staticRenderFns } from "./BullCalfSelection1.vue?vue&type=template&id=79554358&scoped=true&"
import script from "./BullCalfSelection1.vue?vue&type=script&lang=js&"
export * from "./BullCalfSelection1.vue?vue&type=script&lang=js&"
import style0 from "./BullCalfSelection1.vue?vue&type=style&index=0&id=79554358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79554358",
  null
  
)

export default component.exports